import { apiUrl } from "../../config/base.js";
import axios from 'axios';

export default {

	getPropertySuggestions(searchBy, search) {
		return axios.get(apiUrl + '/get-property-suggestions?searchBy=' + searchBy + '&search=' + search);
	},

	search(account_no) {
		return axios.get(apiUrl + '/' + account_no + '/search');
	},

	create(payload) {
		return axios.post(apiUrl + '/protest-requests/store', payload);
	},

	updateSignature(signature, user_property_uid) {
		return axios.post(apiUrl + '/user-properties/' + user_property_uid + '/add-update-authorize-signature', { signature: signature });
	},

	storeEvidences(protest_request_uid, requestPayload, isAdminEditing) {
			// console.log("storeEvidences - requestPayload:",requestPayload);
			var postUrl;
			if(isAdminEditing){
				postUrl = 	apiUrl + '/admin/protest-requests/' + protest_request_uid + '/evidences/upload';
			}else{
				postUrl = 	apiUrl + '/protest-requests/' + protest_request_uid + '/evidences';
			}
			return axios.post(postUrl, requestPayload, {
				headers: {
					'content-type': 'multipart/form-data'
				}
			});
	},
	getCurrentStep(accountNo) {
		return axios.get(apiUrl + '/getCurrentStep/' + accountNo );
	},
	signRevokeAoaAgreement(signature, user_property_uid) {
		return axios.post(apiUrl + '/user-properties/' + user_property_uid + '/add-revoke-aoa-signature', { signature: signature });
	},

	storeAdditionalInformation(protest_request_uid, requestPayload) {
		return axios.post(apiUrl + '/protest-requests/' + protest_request_uid + '/additional-information', requestPayload);
	},

  changeMailingAddress(user_property_uid, payload, is_admin = false){
		if (is_admin) {
			return axios.post(apiUrl + '/admin/aoa-review-system/user-properties/' + user_property_uid + '/change-mailing-address', payload);
		}
        return axios.post(apiUrl + '/user-properties/' + user_property_uid + '/edit', payload);
    },

  storeConfirmToProtest(user_property_uid, payload){
        return axios.post(apiUrl + "/user-properties/" + user_property_uid + '/confirm-to-protest', payload);
  },


	//// Final outcome page api's
	storeFeedbackFormData(payload){
        return axios.post(apiUrl + "/protest-requests/final-outcome/submit-feedback-form", payload);
	},

	getFrequentlyAskedQuestions(){
		return axios.post(apiUrl + "/protest-requests/final-outcome/frequently-asked-questions");
	},







	// by admin
	saveEvidence(requestPayload) {
		return axios.post(apiUrl + '/admin/save-image', requestPayload, {
			headers: {
				'content-type': 'multipart/form-data'
			}
		});
	},
	// by admin
	deleteEvidenceImage(protest_request_evidence_uid, comment) {
		return axios.post(apiUrl + '/admin/' + protest_request_evidence_uid + '/delete-evidence', { comment: comment });
	},

	// by admin
	changeEvidenceStatus(protest_request_uid, comment, statusValue, costOfRepairRating = null, calculatedCostofRepairViaRating = null) {
		return axios.post(apiUrl + '/admin/protest-requests/' + protest_request_uid + '/change-evidence-status', { comment: comment, status: statusValue, costOfRepairRating:costOfRepairRating, calculatedCostofRepairViaRating:calculatedCostofRepairViaRating });
	},

	// by admin
	includeEvidence(protest_request_evidence_uid) {
		return axios.post(apiUrl + '/admin/' + protest_request_evidence_uid + '/include-evidence');
	},

	// by admin
	getInternalUserActivites(protest_request_uid) {
		return axios.post(apiUrl + '/admin/protest-requests/' + protest_request_uid + '/get-internal-user-activites');
	},

	deleteEvidence(protest_request_uid, protest_request_evidence_uid) {
		return axios.delete(apiUrl + '/protest-requests/' + protest_request_uid + '/evidences/' + protest_request_evidence_uid);
	},

	// update(data, protest_request) {
	// 	return axios.post(apiUrl + '/protest-requests/' + protest_request.uid + '/update', { data : data });
	// },

	resignAoaAgreement(signature, user_property_uid) {
		return axios.post(apiUrl + '/user-properties/' + user_property_uid + '/re-sign-aoa', { signature: signature })
	},
	// updateTitles(data, protest_request) {
	// 	return axios.post(apiUrl + '/protest-requests/' + protest_request.uid + '/updateTitles', { data : data });
	// },

	confirmToProtest(user_property_uid, payload) {
		return axios.post(apiUrl + "/user-properties/" + user_property_uid + '/confirm-to-protest', payload);
	},

	update(protest_request_uid, payload, is_admin = false) {
		if (is_admin) {
			return axios.post(apiUrl + "/admin/protest-requests/" + protest_request_uid + '/update', payload);
		}

		return axios.post(apiUrl + "/protest-requests/" + protest_request_uid + '/update', payload);
	},

	adminGenerateEvidenceReportPDF(protest_request_uid){
		return axios.post(apiUrl + "/admin/protest-requests/" + protest_request_uid + '/generateEvidenceReportPDF', null);
	}


}

